<template>
  <div>
    <v-navigation-drawer v-model="drawer" fixed app>
      <v-list-item v-if="loggedIn">
        <v-list-item-content>
          <v-list-item-title class="title">
            <v-icon>account_circle</v-icon>Admin
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-btn @click="logout" color="secondary" small>Logout</v-btn>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list>
        <template v-for="(item, i) in items">
          <v-list-item :key="i" v-if="item.show && !item.items" link :href="item.link" :to="{ path: item.link }">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>

          <v-list-group v-if="item.show && item.items" :prepend-icon="item.icon" :key="i">
            <template v-slot:activator>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </template>
            <v-list-item v-for="(itemSubmenu, j) in item.items" :key="j" link class="pl-10" :href="itemSubmenu.link"
              :to="{ path: itemSubmenu.link }">
              <v-list-item-icon>
                <v-icon v-text="itemSubmenu.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="itemSubmenu.title">
              </v-list-item-title>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <div @click="goBack" v-if="this.$route.path != '/'">
        <v-btn text small>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </div>
      <v-toolbar-title>{{ currentRouteName }}</v-toolbar-title>
    </v-app-bar>
  </div>
</template>

<script>
import {
  hasAccess,
  PERMISSION_LEVEL_ADMIN,
PERMISSION_LEVEL_TECHNICIAN_ANRE,
} from '../../utils/permissions';

export default {
  name: 'MainNavigation',
  components: {},
  data: () => ({
    drawer: null,
    items: [
      {
        title: 'Dashboard',
        icon: 'dashboard',
        link: '/dashboard',
        show: hasAccess(PERMISSION_LEVEL_ADMIN),
      },
      {
        title: 'Mesaje',
        icon: 'question_answer',
        link: '/alerts',
        show: hasAccess(PERMISSION_LEVEL_ADMIN),
      },
      {
        title: 'Clienti',
        icon: 'supervisor_account',
        link: '/clients',
        show: hasAccess(PERMISSION_LEVEL_TECHNICIAN_ANRE),
      },
      {
        title: 'Facturi Servicii',
        icon: 'insert_drive_file',
        link: '/documents',
        show: hasAccess(PERMISSION_LEVEL_ADMIN),
      },
      {
        title: 'Agenda',
        icon: 'event',
        link: '/tasks',
        show: hasAccess(PERMISSION_LEVEL_TECHNICIAN_ANRE),
      },
      {
        title: 'Gestiune',
        icon: 'inventory_2',
        link: '/products',
        show: hasAccess(PERMISSION_LEVEL_ADMIN),
      },
      {
        title: 'Utilizatori',
        icon: 'https',
        link: '/users',
        show: hasAccess(PERMISSION_LEVEL_ADMIN),
      },
      {
        title: 'Evidenta',
        icon: 'dns',
        link: '',
        show: hasAccess(PERMISSION_LEVEL_ADMIN),
        items: [
          { title: 'Plati Numerar', icon: 'paid', link: '/expenses/cash' },
          { title: 'Plati Banca', icon: 'mdi-credit-card-outline', link: '/expenses/bank' },
          {
            title: 'Export Registru',
            icon: 'price_change',
            link: '/cash-register',
          },
        ],
      },
      {
        title: 'Export fisiere',
        icon: 'download',
        link: '/export',
        show: hasAccess(PERMISSION_LEVEL_TECHNICIAN_ANRE),
      },
      {
        title: 'Analizoare',
        icon: 'settings_remote',
        link: '/analyzers',
        show: hasAccess(PERMISSION_LEVEL_ADMIN),
      },
      {
        title: 'Setari',
        icon: 'settings',
        link: '/settings',
        show: hasAccess(PERMISSION_LEVEL_ADMIN),
      },
    ],
  }),
  created() {
    this.username = this.$store.state.auth.username;
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    loggedIn() {
      return this.$store.getters['auth/isLoggedIn'];
    },
  },
  methods: {
    redirect(url) {
      this.$router.push(url);
    },
    goBack() {
      this.$router.back();
    },
    logout() {
      this.$store.dispatch('auth/logout');
      this.$router.push({ path: '/login' });
    },
  },
};
</script>

<style scoped>

</style>
